import BadgesColumns from "trail/users/badges/BadgesColumns"

export { BadgesColumns }
